module.exports = __webpack_public_path__ + "img/more-activity-title.9b3ce1f3.png";